import React from 'react';
import { Button } from 'src/components/ui/button';
import BorderedSelect from 'src/components/form-new/bordered-select';

const PAGE_SIZE_OPTIONS = [
  { value: '25', label: '25 per page' },
  { value: '50', label: '50 per page' },
  { value: '100', label: '100 per page' },
];

export interface ManageListPaginationProps {
  page: number;
  totalPages: number;
  totalObjects: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  disabled?: boolean;
}

const ManageListPagination: React.FC<ManageListPaginationProps> = ({
  page,
  totalPages,
  totalObjects,
  pageSize,
  onPageChange,
  onPageSizeChange,
  disabled = false,
}) => {
  const safeTotalPages = Math.max(1, totalPages);
  const start = totalObjects === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalObjects);

  return (
    <div className="mt-3 flex flex-wrap items-center justify-between gap-3 border-t border-gray-200 bg-gray-50/80 px-1 pt-4 pb-3">
      <p className="text-sm text-gray-600">
        {totalObjects === 0 ? (
          'No results'
        ) : (
          <>
            Showing
            {' '}
            <span className="font-medium text-gray-900">
              {start}
              –
              {end}
            </span>
            {' '}
            of
            {' '}
            <span className="font-medium text-gray-900">
              {totalObjects}
            </span>
          </>
        )}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <BorderedSelect
          label="Page size"
          options={PAGE_SIZE_OPTIONS}
          value={String(pageSize)}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          containerMaxWidth="140px"
          disabled={disabled}
        />
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={disabled || page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </Button>
        <span className="text-sm text-gray-700 tabular-nums">
          Page
          {' '}
          {page}
          {' '}
          /
          {' '}
          {safeTotalPages}
        </span>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={disabled || page >= safeTotalPages || totalObjects === 0}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default ManageListPagination;
